import { render, staticRenderFns } from "./FormPic.vue?vue&type=template&id=bd72ab48&scoped=true"
import script from "./FormPic.vue?vue&type=script&lang=ts"
export * from "./FormPic.vue?vue&type=script&lang=ts"
import style0 from "./FormPic.vue?vue&type=style&index=0&id=bd72ab48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd72ab48",
  null
  
)

export default component.exports